import DatePicker from '@/common/components/Inputs/DatePicker/DatePicker';

export default DatePicker;
